/**
* 系统管理 用户管理
*/
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/welcome' }">基础信息管理</el-breadcrumb-item>
      <el-breadcrumb-item>用户信息管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="学校：">
        <el-select size="small" v-model="formInline.school" clearable>
          <el-option label="全部" value=""></el-option>
          <el-option v-for="item in schoolSelect" :key="item.id" :value="item.id" :label="item.name"/>
        </el-select>
      </el-form-item>
      <el-form-item label="用户名：">
        <el-input size="small" v-model="formInline.username" placeholder="输入用户名" clearable></el-input>
      </el-form-item>
      <el-form-item label="学生认证状态：">
        <el-select size="small" v-model="formInline.status" clearable>
          <el-option label="全部" value=""></el-option>
          <el-option label="待认证" value="0"></el-option>
          <el-option label="已认证" value="1"></el-option>
          <el-option label="认证拒绝" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="跑腿认证状态：">
        <el-select size="small" v-model="formInline.courierStatus" clearable>
          <el-option label="全部" value=""></el-option>
          <el-option label="待申请" value="0"></el-option>
          <el-option label="申请通过" value="1"></el-option>
          <el-option label="申请拒绝" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-checkbox v-model="formInline.adminType" true-label="ORDINARY_ADMIN" false-label="" style="width: 100px">平台管理员</el-checkbox>
      </el-form-item>
      <el-form-item>
        <el-checkbox v-model="formInline.banStatus" true-label="1" false-label="" style="width: 70px">封禁</el-checkbox>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">查询</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="userData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" prop="adminType" label="用户类型" width="120">
        <template v-slot:default="scope">
          <el-link v-if="scope.row.adminType == 'ADMIN'" type="danger" :underline="false">超级管理员</el-link>
          <el-link v-else-if="scope.row.adminType == 'ORDINARY_ADMIN'" type="primary" @click="updateAdminType(scope.$index, scope.row, '')">平台管理员</el-link>
          <el-link v-else @click="updateAdminType(scope.$index, scope.row, 'ORDINARY_ADMIN')">普通用户</el-link>
        </template>
      </el-table-column>
      <el-table-column align="center" sortable prop="schoolName" label="学校" width="150" show-overflow-tooltip/>
      <el-table-column align="center" prop="avatar" label="用户头像" width="100">
        <template v-slot:default="scope">
          <el-avatar v-if="scope.row.avatar != null && scope.row.avatar != ''" :size="50" :src="scope.row.avatar"/>
          <div class="noavatar" v-else>无</div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="username" label="用户名" width="150" show-overflow-tooltip/>
      <el-table-column align="center" prop="gender" label="性别" width="100"/>
      <el-table-column align="center" prop="mobile" label="手机号" width="150"/>
      <el-table-column align="center" label="学生认证信息" width="150">
        <template v-slot:default="scope">
          <el-image v-if="scope.row.verifyInfo != null" style="width: 50px; height: 50px" :src="scope.row.verifyInfo" :preview-src-list="picturePreview(scope.row.verifyInfo)"/>
          <div v-if="scope.row.status==1">
            <el-link icon="el-icon-circle-check" type="success" :underline="false">已认证</el-link>
          </div>
          <div v-else-if="scope.row.status==2">
            <el-link icon="el-icon-circle-close" type="danger" :underline="false">认证拒绝</el-link>
          </div>
          <div v-else>
            <el-link icon="el-icon-circle-close" type="primary" @click="userStatusUpdate(scope.$index, scope.row, 2)">拒绝</el-link>
            <el-link icon="el-icon-circle-check" type="primary" @click="userStatusUpdate(scope.$index, scope.row, 1)">通过</el-link>
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="跑腿认证信息" width="150">
        <template v-slot:default="scope">
          <el-image v-if="scope.row.idCardInfo != null" style="width: 50px; height: 50px" :src="scope.row.idCardInfo" :preview-src-list="picturePreview(scope.row.idCardInfo)"/>
          <div v-if="scope.row.courierStatus==0 && scope.row.idCardInfo != null">
            <el-link icon="el-icon-circle-close" type="primary" @click="userCourierStatusUpdate(scope.$index, scope.row, 2)">拒绝</el-link>
            <el-link icon="el-icon-circle-check" type="primary" @click="userCourierStatusUpdate(scope.$index, scope.row, 1)">通过</el-link>
          </div>
          <div v-else>
            <el-link icon="el-icon-circle-check" type="success" :underline="false" v-if="scope.row.courierStatus==1">申请通过</el-link>
            <el-link icon="el-icon-circle-close" type="danger" :underline="false" v-else-if="scope.row.courierStatus==2">申请拒绝</el-link>
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="封禁状态" show-overflow-tooltip>
        <template v-slot:default="scope">
          <div slot="reference" class="name-wrapper">
            <el-tag v-if="scope.row.banStatus == 0" size="medium">未封禁</el-tag>
            <el-tag v-else-if="scope.row.banStatus == 1" size="medium" type="warning">封禁中：{{ scope.row.banEndTime }}</el-tag>
            <el-tag v-else-if="scope.row.banStatus == 2" size="medium" type="danger">永久封禁</el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" sortable prop="gmtCreate" label="注册时间" width="160"/>
      <el-table-column align="center" sortable prop="gmtUpdate" label="更新时间" width="160"/>
      <el-table-column align="center" label="操作" width="240" fixed="right">
        <template v-slot:default="scope">
          <!--删除、编辑-->
          <el-button size="mini" type="danger" @click="remove(scope.$index, scope.row)">删除</el-button>
          <el-button size="mini" type="primary" @click="edit(scope.$index, scope.row)">编辑</el-button>
          <!--封禁、解除封禁-->
          <el-button size="mini" type="warning" v-if="scope.row.banStatus == 0" @click="ban(scope.$index, scope.row)">封禁</el-button>
          <el-button size="mini" type="success" v-if="scope.row.banStatus != 0" @click="unban(scope.$index, scope.row)">解封</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageParam" @callFather="callFather"></Pagination>

    <!-- 编辑界面 -->
    <el-dialog title="封禁" :close-on-click-modal="false" :visible.sync="banFormVisible" width="30%" @click='closeDialog("ban")'>
      <el-form label-width="80px" ref="banForm" :model="banForm" :rules="rules">
        <el-form-item label="* 封禁时长" prop="status">
          <el-select size="small" v-model="banForm.hourDuration" placeholder="请选择封禁时长" style="width: 90%">
            <el-option label="1小时" value="1"></el-option>
            <el-option label="4小时" value="4"></el-option>
            <el-option label="8小时" value="8"></el-option>
            <el-option label="12小时" value="12"></el-option>
            <el-option label="24小时" value="24"></el-option>
            <el-option label="7天" value="168"></el-option>
            <el-option label="永久封禁" value="999"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("ban")'>取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="banSubmitForm('banForm')">保存
        </el-button>
      </div>
    </el-dialog>

    <!-- 编辑界面 -->
    <el-dialog :title="title" :close-on-click-modal="false" :visible.sync="editFormVisible" width="60%" @click='closeDialog("edit")'>
      <el-form label-width="100px" ref="editForm" :model="editForm" :rules="rules">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="头像" prop="avatar">
              <el-avatar v-if="editForm.avatar != null && editForm.avatar != ''" :size="50" :src="editForm.avatar"/>
              <div class="noavatar" v-else><span>无</span></div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="学校" prop="school">
              <el-select size="small" v-model="editForm.school" style="width: 100%">
                <el-option v-for="item in schoolSelect" :key="item.id" :value="item.id" :label="item.name"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="用户名" prop="username">
              <el-input size="small" v-model="editForm.username" placeholder="请输入用户名" maxlength="50"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="性别" prop="gender">
              <el-select size="small" v-model="editForm.gender" style="width: 100%">
                <el-option label="男" value="男"></el-option>
                <el-option label="女" value="女"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="手机号" prop="mobile">
              <el-input size="small" v-model="editForm.mobile" placeholder="请输入手机号" maxlength="11"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="地址" prop="address">
              <el-input size="small" v-model="editForm.address" placeholder="请输入地址" maxlength="50"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="学生认证状态" prop="status">
              <el-input v-if="editForm.status == 2" size="small" :disabled="true" value="认证拒绝"/>
              <el-input v-else-if="editForm.status == 1" size="small" :disabled="true" value="已认证"/>
              <el-input v-else size="small" :disabled="true" value="待认证"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="跑腿认证状态" prop="courierStatus">
              <el-input v-if="editForm.courierStatus == 2" size="small" :disabled="true" value="申请拒绝"/>
              <el-input v-else-if="editForm.courierStatus == 1" size="small" :disabled="true" value="申请通过"/>
              <el-input v-else size="small" :disabled="true" value="待申请"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="封禁状态" prop="banStatus">
              <el-input v-if="editForm.banStatus == 2" size="small" :disabled="true" value="永久封禁"/>
              <el-input v-else-if="editForm.banStatus == 1" size="small" :disabled="true" value="封禁中"/>
              <el-input v-else size="small" :disabled="true" value="未封禁"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("edit")'>取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// 导入请求方法
import {userList, userUpdate, userStatusUpdate, ban, unban, remove, updateAdminType} from '../../api/userMG'
import {schoolList} from '../../api/schoolMG'
import Pagination from '../../components/Pagination'

export default {
  data() {
    return {
      loading: false, //是显示加载
      title: '添加用户',
      editFormVisible: false, //控制编辑页面显示与隐藏
      banFormVisible: false,  //封禁用户页面显示与隐藏
      // 封禁用户表单
      banForm: {
        id: '',
        hourDuration: ''
      },
      // 编辑与添加
      editForm: {
        id: '',
        avatar: '',
        school: '',
        username: '',
        gender: '',
        mobile: '',
        address: '',
        status: '',
        courierStatus: '',
        banStatus: ''
      },
      // rules表单验证
      rules: {
        username: [{required: true, message: '请输入用户名', trigger: 'blur'}]
      },
      //列表查询参数
      formInline: {
        page: 1,
        limit: 20,
        adminType: '',
        school: '',
        username: '',
        status: '',
        courierStatus: '',
        banStatus: ''
      },
      schoolSelect: [], //学校列表
      userData: [], //用户列表
      // 分页参数
      pageParam: {
        currentPage: 1,
        pageSize: 20,
        total: 20
      },
      //角色列表
      roleList: []
    }
  },
  // 注册组件
  components: {
    Pagination
  },

  /**
   * 数据发生改变
   */
  watch: {},

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
    this.querySchoolList()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    //查询学校列表
    querySchoolList: function () {
      schoolList().then(res => {
        this.loading = false
        if (res.code == 0) {
          res.data.forEach(item => {
            this.schoolSelect.push(item);
          })
        } else {
          this.$message({type: 'info', message: res.msg})
        }
      }).catch(() => {
        this.$message({type: 'info', message: res.msg})
      })
    },
    // 获取数据方法
    getdata(parameter) {
      this.loading = true
      this.loading = false
      //获取用户列表
      userList(parameter).then(res => {
        this.loading = false
        if (res.code != 0) {
          this.$message({type: 'info', message: res.msg})
        } else {
          this.userData = res.data.list
          // 分页赋值
          this.pageParam.currentPage = res.data.page
          this.pageParam.pageSize = res.data.limit
          this.pageParam.total = res.data.total
        }
      })
    },
    // 分页插件事件
    callFather(param) {
      this.formInline.page = param.currentPage
      this.formInline.limit = param.pageSize
      this.getdata(this.formInline)
    },
    //搜索事件
    search() {
      this.getdata(this.formInline)
    },
    // 修改type
    editType: function (index, row) {
      this.loading = true
      let parm = {
        status: '',
        id: '',
        token: localStorage.getItem('logintoken')
      }
      parm.id = row.id
      let status = row.status
      if (status == '1') {
        parm.status = '2'
      } else {
        parm.status = '1'
      }
      // 修改状态
      userEdit(parm).then(res => {
        this.loading = false
        if (res.success == false) {
          this.$message({
            type: 'info',
            message: res.message
          })
        } else {
          this.$message({
            type: 'success',
            message: '状态修改成功'
          })
          this.getdata(this.formInline)
        }
      })
    },
    //显示编辑界面
    edit: function (index, row) {
      this.editFormVisible = true
      this.title = '用户信息修改'
      this.editForm.id = row.id
      this.editForm.avatar = row.avatar
      this.editForm.school = row.school
      this.editForm.username = row.username
      this.editForm.gender = row.gender
      this.editForm.mobile = row.mobile
      this.editForm.address = row.address
      this.editForm.status = row.status
      this.editForm.courierStatus = row.courierStatus
      this.editForm.banStatus = row.banStatus
    },
    // 编辑、添加提交方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          var params = this.editForm;
          delete params.status;
          delete params.courierStatus;
          delete params.banStatus;
          console.log(params)
          userUpdate(params).then(res => {
            this.editFormVisible = false
            this.loading = false
            if (res.code == 0) {
              this.getdata(this.formInline)
              this.$message({type: 'success', message: '数据更新成功！'})
            } else {
              this.$message({type: 'info', message: res.message})
            }
          })
        } else {
          return false
        }
      })
    },
    // 关闭编辑、增加弹出框
    closeDialog(dialog) {
      if (dialog == 'edit') {
        this.editFormVisible = false
      } else if (dialog == 'ban') {
        this.banFormVisible = false
      }
    },
    //封禁
    ban(index, row) {
      this.banFormVisible = true;
      this.banForm.id = row.id;
      this.banForm.hourDuration = "1";
      console.log(this.banForm)
    },
    //封禁信息保存
    banSubmitForm() {
      this.loading = true
      ban(this.banForm).then(res => {
        this.banFormVisible = false
        this.loading = false
        if (res.code == 0) {
          this.getdata(this.formInline)
          this.$message({type: 'success', message: '封禁成功！'})
        } else {
          this.$message({type: 'warning', message: res.msg})
        }
      }).catch(err => {
        this.banFormVisible = false
        this.loading = false
        this.$message.error('保存失败，请稍后再试！')
      })
    },
    //解除封禁
    unban(index, row) {
      this.$confirm('确认解除此用户的封禁状态?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        unban({id: row.id}).then(res => {
          if (res.code == 0) {
            this.$message({type: 'success', message: '解除成功!'})
            this.getdata(this.formInline)
          } else {
            this.$message({type: 'warning', message: res.msg})
          }
        }).catch(err => {
          this.loading = false
          this.$message.error('解除失败，请稍后再试！')
        })
      }).catch(() => {
        this.$message({type: 'info', message: '已取消解封！'})
      })
    },
    // 学生认证状态变更
    userStatusUpdate(index, row, status) {
      let params = {};
      params.id = row.id;
      params.status = status;
      var message = (status == 1 ? '通过' : '拒绝');
      this.$confirm('此操作无法撤销，确认' + message + '此用户学生认证?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        userStatusUpdate(params).then(res => {
          if (res.code == 0) {
            this.$message({type: 'success', message: message + '成功!'})
            this.getdata(this.formInline)
          } else {
            this.$message({type: 'warning', message: res.msg})
          }
        }).catch(err => {
          this.loading = false
          this.$message.error(message + '失败，请稍后再试！')
        })
      }).catch(() => {
        this.$message({type: 'info', message: '已取消' + message + '！'})
      })
    },
    // 跑腿认证状态变更
    userCourierStatusUpdate(index, row, status) {
      let params = {};
      params.id = row.id;
      params.courierStatus = status;
      var message = (status == 1 ? '通过' : '拒绝');
      this.$confirm('此操作无法撤销，确认' + message + '此用户跑腿认证?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        userStatusUpdate(params).then(res => {
          if (res.code == 0) {
            this.$message({type: 'success', message: message + '成功!'})
            this.getdata(this.formInline)
          } else {
            this.$message({type: 'warning', message: res.msg})
          }
        }).catch(err => {
          this.loading = false
          this.$message.error(message + '失败，请稍后再试！')
        })
      }).catch(() => {
        this.$message({type: 'info', message: '已取消' + message + '！'})
      })
    },
    //用户删除
    remove(index, row) {
      this.$confirm('用户删除后无法回复，确认删除?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        remove({'id': row.id}).then(res => {
          if (res.code == 0) {
            this.$message({type: 'success', message: '删除成功!'})
            this.getdata(this.formInline)
          } else {
            this.$message({type: 'warning', message: res.msg})
          }
        }).catch(err => {
          this.loading = false
          this.$message.error('删除失败，请稍后再试！')
        })
      }).catch(() => {
        this.$message({type: 'info', message: '已取消删除操作！'})
      })
    },
    //用户类型变更
    updateAdminType(index, row, adminType) {
      let params = {};
      params.id = row.id;
      params.adminType = adminType;
      if (adminType == 'ORDINARY_ADMIN' && row.mobile == '') {
        this.$message({type: 'warning', message: '用户手机号为空，无法设置为平台管理员！'})
        return;
      }
      var msg = adminType == 'ORDINARY_ADMIN'?'平台管理员具备帖子管理权限（密码重置为：wall@2024），确认变更？':'平台管理员具备帖子管理权限，确认取消？';
      this.$confirm(msg, '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        updateAdminType(params).then(res => {
          if (res.code == 0) {
            this.$message({type: 'success', message: '变更成功!'})
            this.getdata(this.formInline)
          } else {
            this.$message({type: 'warning', message: res.msg})
          }
        }).catch(err => {
          this.loading = false
          this.$message.error('变更失败，请稍后再试！')
        })
      }).catch(() => {
        this.$message({type: 'info', message: '已取消变更！'})
      })
    },
    // 重置密码
    resetpwd(index, row) {
      this.resetpsd.id = row.id
      this.$confirm('确定要重置密码吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          userPwd(this.resetpsd)
            .then(res => {
              if (res.success) {
                this.$message({
                  type: 'success',
                  message: '重置密码成功！'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.message
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('重置密码失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '取消重置密码！'
          })
        })
    },
    //图片预览大图
    picturePreview(src) {
      let list = [src];
      return list;
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}

.noavatar {
  width: 50px;
  height: 50px;
  line-height: 50px;
  border: 1px solid dimgrey;
  background-color: #9d9d9d;
  border-radius: 50%;
  margin-left: 15px;
  text-align: center;
}
</style>




// WEBPACK FOOTER //
// src/views/system/User.vue